import { setSortColumnAndDirection } from '../../actions/approvalRequestsTable'
import { isEmpty } from '../../utils/common'

const mapStateToProps = state => {
  const {
    approvalRequestsTable: { sortColumn, sortDir },
  } = state

  return {
    sortColumn,
    sortDir,
  }
}

const SORT_TERMS = {
  asc: 'ascending',
  desc: 'descending',
}

const DisplayTitle = ({ srOnly, title, sortable = true }) => (
  <span
    className={srOnly ? 'sr-only' : undefined}
    style={!sortable ? { display: 'block', padding: '11px 8px 12px 8px' } : {}}
  >
    {title}
  </span>
)

const SortableTableHeaderItem = connect(mapStateToProps, { setSortColumnAndDirection })(
  ({
    index,
    columnKey,
    hiddenColumns,
    sortDir,
    sortColumn,
    headerText,
    headerAttributes,
    sortable,
    setSortColumnAndDirection,
  }) => {
    const [sortDirection, setSortDirection] = useState('')

    useEffect(() => {
      if (sortDir && sortColumn === index) {
        setSortDirection(SORT_TERMS[sortDir[0]])
      } else {
        setSortDirection(null)
      }
    }, [sortDir, sortColumn])

    const handleClick = e => {
      e.preventDefault()
      const updatedSortDir = JSON.parse(
        Array.isArray(sortDir) ? JSON.stringify(sortDir) : JSON.stringify([sortDir])
      )
      // Changing sort order by clicking column header only ever changes the primary sort order
      updatedSortDir[0] = updatedSortDir[0] === 'asc' ? 'desc' : 'asc'
      setSortColumnAndDirection({ column: index, direction: updatedSortDir })
    }

    if (!columnKey?.length || (columnKey.length && !hiddenColumns.includes(columnKey[0]))) {
      return (
        <th
          {...headerAttributes}
          scope="col"
          aria-sort={sortDir ? sortDirection || 'none' : null}
          data-colsort={sortDir ? sortDirection || 'none' : null}
        >
          {sortable ? (
            <a
              href="#"
              onClick={handleClick}
              aria-describedby={sortDirection ? null : `sortable-column-${sortDir[0]}`}
            >
              <DisplayTitle srOnly={headerText.srOnly} title={headerText.title} />
              <i
                className={`cb-glyph cb-sort${sortDirection ? `-${sortDir[0]}` : ''}`}
                aria-hidden="true"
              />
            </a>
          ) : (
            <DisplayTitle srOnly={headerText.srOnly} title={headerText.title} sortable={false} />
          )}
        </th>
      )
    }
    return null
  }
)

const SortableTableHeader = ({ columns, hiddenColumns = [], style = {} }) => (
  <thead style={style}>
    <tr>
      {columns.map((column, index) => (
        <SortableTableHeaderItem
          key={column.headerAttributes.id}
          index={index}
          columnKey={column.key}
          hiddenColumns={hiddenColumns}
          headerText={column.headerText}
          headerAttributes={column.headerAttributes}
          sortable={!isEmpty(column.key)}
        />
      ))}
    </tr>
  </thead>
)

export default SortableTableHeader
